enum ApiErrorCodeLookup {
  JwtIsInvalidError = '620f55db',
}

export default ApiErrorCodeLookup
